// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { showWarning } from "src/utils/toast/toastUtil";
import { PRD3020_R01Dto } from "./Dto_PRD3020_R01";


export const headerNames_PRD3020_R01: Record<string, string> = {
	rowIndex: "",
	productOrderNo: '작업지시번호',
	compCd: '사업장',
	orderDt: '작업일자',
	orderType: '지시구분',
	workplaceCd: '작업공정',
	workProcess: '공정유형',
	jobTeam: '작업팀',
	totalDowntimeMinutes: '총 비가동시간',
	orderEmp: '작업자',
	orderEmpNm: '작업자(명)',
	itemCd: '품목코드',
	itemNm: '품명',
	itemSpec: '규격',
	itemUnit: '단위',
	orderQty: '수량',
	remark: '비고',
}

export const headerNames_PRD3020_R01_Detail: Record<string, string> = {
	rowIndex: '',
	downtimeNo: '비가동번호',
	downtimeCase: '비가동사유',
	fromTime: '비가동시작시간',
	toTime: '비가동종료시간',
	downtimeMinutes: '비가동시간',
};

export const getDowntimeMinutes = (
	fromTime: Date | string | undefined,
	toTime: Date | string | undefined,
): number | null => {
	if (fromTime === undefined || toTime === undefined) return null;

	const fromMilliseconds = new Date(fromTime).getTime();
	const toMilliseconds = new Date(toTime).getTime();
	if (!Number.isFinite(fromMilliseconds) || !Number.isFinite(toMilliseconds)) return null;
	if (toMilliseconds < fromMilliseconds) return null;

	return Math.floor((toMilliseconds - fromMilliseconds) / 60_000);
};

export const formatDowntimeMinutes = (minutes: number | null | undefined): string => {
	if (minutes === null || minutes === undefined || !Number.isFinite(minutes) || minutes < 0) return '';

	const totalMinutes = Math.floor(minutes);
	const hours = Math.floor(totalMinutes / 60);
	const remainingMinutes = totalMinutes % 60;
	return `${hours}:${remainingMinutes.toString().padStart(2, '0')}`;
};

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: PRD3020_R01Dto,
  updatePRD3020_R01List: (index: number, data: PRD3020_R01Dto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updatePRD3020_R01List(valueIndex, {
      ...originalData,
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
        targetNode.setDataValue('itemCd', originalData.itemCd);
        targetNode.setDataValue('itemNm', originalData.itemNm);
        targetNode.setDataValue('itemSpec', originalData.itemSpec);
        targetNode.setDataValue('itemUnit', originalData.itemUnit);
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalPRD3020_R01List: PRD3020_R01Dto[],
  deletedMST1020_R01BomDetailList: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalPRD3020_R01List.find(item => item.valueIndex === params.data?.valueIndex);
  return true;
}

// 날짜 컬럼 클릭 시 편집 가능 여부
export function validateDateColumns(
  field: string,
  data: any,
  originalPRD3020_R01List: PRD3020_R01Dto[],
  dateColumns: string[]
): boolean {
  const originalData = originalPRD3020_R01List.find(item => item.valueIndex === data.valueIndex);
  return true;
}

// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}

// 중복 체크
export function isDuplicateChildItemcd(
  list: PRD3020_R01Dto[],
  itemCd: string,
  valueIndex: number
) {
  return list.filter(item => item.itemCd === itemCd && item.valueIndex !== valueIndex).length > 0;
}
